// extracted by mini-css-extract-plugin
export var cartContainer = "_jd-4";
export var gray = "_jd-1";
export var itemContainer = "_jd-2";
export var itemDetails = "_jd-3";
export var strong = "_jd-0";